import type { TCountryCode } from "countries-list";
import type { FC } from "react";
import Flag, { getFlag } from "../../../components/general/Flag/Flag";
import Icon from "../../../components/general/Icon/Icon";
import { nonEmptyArray } from "../../../utils/type-guards/general";
import Link from "../Link";
import InformationSlideShow from "./components/InformationSlideShow";

export type TopBarInformationProps = {
	_uid: string;
	icon: string;
	text: string;
	href?: string;
};

type Props = {
	information: TopBarInformationProps[];
	findStore: { label: string; link: string };
	helpCenter: { label: string; link: { href: string; target?: string } };
	flagAriaLabel: string;
	openLanguageModal: () => void;
	userCountry?: TCountryCode;
	allowedCountries: [TCountryCode, ...TCountryCode[]];
};

const TopBar: FC<Props> = ({
	information,
	helpCenter,
	findStore,
	openLanguageModal,
	flagAriaLabel,
	userCountry,
	allowedCountries,
}) => {
	const flag = getFlag(allowedCountries, userCountry);
	if (!nonEmptyArray(information)) return null;

	return (
		<div className="flex h-10 items-center justify-between bg-white">
			<InformationSlideShow information={information} />
			<div className="bb-text-micro divide-gray-1 flex items-center divide-x [&>*:not(:first-child)]:pl-2 [&>*:not(:last-child)]:pr-2">
				<Link
					className="hidden !underline hover:!no-underline md:block"
					href={helpCenter.link.href}
					target={helpCenter.link.target}
				>
					{helpCenter.label}
				</Link>

				<Link
					className="hidden !underline hover:!no-underline md:block"
					href={findStore.link}
				>
					{findStore.label}
				</Link>

				<Link
					className="md:hidden"
					href={findStore.link}
					aria-label={findStore.label}
				>
					<Icon icon="location" width={18} height={18} />
				</Link>

				<button
					className="flex"
					onClick={openLanguageModal}
					aria-label={`${flagAriaLabel} ${flag}`}
				>
					<Flag flagOverride={flag} ariaLabel={`${flagAriaLabel} ${flag}`} />
				</button>
			</div>
		</div>
	);
};

export default TopBar;
